<template>
    <div class="gift-ideas-container">
        <div class="top-white-box"></div>
        <template v-if="isLoading">
            <div class="gift-ideas-list-title shimmer-container">
                <div class="shimmer shimmer-title"></div>
            </div>
            <div class="gift-ideas-list-img shimmer-container">
                <div class="shimmer shimmer-image"></div>
            </div>
            <div class="gift-ideas-list-desc shimmer-container">
                <div class="shimmer shimmer-text"></div>
                <div class="shimmer shimmer-text"></div>
                <div class="shimmer shimmer-text"></div>
            </div>
            <div class="article-deals-container">
                <Deals :listOfDeals="null" :showPrice="false"></Deals>
            </div>
        </template>
        <template v-else>
            <div class="gift-ideas-list-title" v-if="!isClean && articleDetails">
                <h1>{{ articleDetails.title }}</h1>
            </div>
            <div class="gift-ideas-list-img" v-if="!isClean && articleDetails">
                <img :src="articleDetails.imgUrl" alt="articleDetails.title" />
            </div>
            <div class="gift-ideas-list-desc" v-if="!isClean && articleDetails">{{ articleDetails.desc }}</div>
            <div v-if="articleDetails" class="article-deals-container">
                <Deals :listOfDeals="articleDetails?.deals || []" :showPrice="false"></Deals>
            </div>
        </template>

        <div class="top-gray-box" v-if="articleDetails">
            <h1>Other Gift Ideas You Might Like</h1>
        </div>
        <Articles :excludeArticles="Number($route.params.id)" v-if="articleDetails" />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import api from '@/api'
import settings from '@/settings'
import Articles from "@/components/Articles.vue"
import Deals from "@/components/Deals.vue"
import { Article } from '@/classes/Articles'

export default defineComponent({
    name: "giftlist",
    components: {
        Articles,
        Deals
    },
    setup() {
        const route = useRoute()
        const router = useRouter()
        const isParticipant = ref(false)
        const isLoading = ref(false)
        const articleDetails = ref<Article | null>(null)
        const articleUrl = ref<string | null>(null)
        const isClean = ref(false)

        const init = async () => {
            isLoading.value = true
            const articleId = Number(route.params.id)
            articleDetails.value = null

            try {
                const response = await api.getArticleDetails(articleId, true)
                // Convert to Article instance to ensure proper property mapping
                const tmpArticleDetails = new Article(response.data)
                tmpArticleDetails.imgUrl = 'https://' + settings.siteUrl + tmpArticleDetails.imgUrl

                articleDetails.value = tmpArticleDetails
                document.title = articleDetails.value.pageTitle + ' | ' + settings.siteNameCaps
            } finally {
                isLoading.value = false
            }
        }

        onMounted(() => {
            const cookie_lastref = document.cookie.split('; ').find(row => row.startsWith('MMD_ParticipantRefCode='))
            if (cookie_lastref) {
                isParticipant.value = true
            }

            isClean.value = !!route.query.direct
            init()
        })

        return {
            isParticipant,
            isLoading,
            articleDetails,
            articleUrl,
            isClean,
            linkToJoinWhatsAppGroup: settings.socialLinks.whatsapp
        }
    }
})
</script>

<style scoped>
.shimmer-container {
    margin: 0 auto;
    max-width: 1000px;
}

.shimmer {
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f9;
    background-image: linear-gradient(to right, #f6f7f9 0%, #e9ebee 20%, #f6f7f9 40%, #f6f7f9 100%);
    background-repeat: no-repeat;
    background-size: 800px 104px;
    border-radius: 4px;
}

@keyframes placeHolderShimmer {
    0% {
        background-position: -468px 0;
    }
    100% {
        background-position: 468px 0;
    }
}

.shimmer-title {
    width: 70%;
    height: 40px;
    margin: 50px 15px;
}

.shimmer-image {
    width: 100%;
    height: 400px;
    margin: 0 auto;
    max-width: 1000px;
}

.shimmer-text {
    width: 100%;
    height: 25px;
    margin-bottom: 15px;
}

.shimmer-text:last-child {
    width: 80%;
}
</style>
